import React from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from '@/components/common/TextInput';
import { FormGroupProps } from './types';

type Props = FormGroupProps & {
  handleAlbumMetaData: (field: string, value: string | null) => void;
};

export default function BoxCountFormGroup({
  album,
  readonly,
  disabled,
  fieldHasErrors,
  findErrorMessage,
  handleAlbumMetaData,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <TextInput
        labelClassName="col-sm-3 form-label"
        labelTitle={t('product.editProduct.boxCount')}
        handleInput={(e) => handleAlbumMetaData('boxCount', e.target.value)}
        id="boxCount"
        type="text"
        min={0}
        unsignedIntegerOnly
        value={album.albumMetaData?.boxCount?.toString() ?? ''}
        inputClassname="form-control"
        className="col-sm-6"
        isDisabled={disabled}
        isReadOnly={readonly}
        hasErrors={fieldHasErrors('BoxCount')}
        errorMessage={findErrorMessage('BoxCount')}
      />
    </div>
  );
}
